import React, { useState } from 'react';
import logo from '../../assets/logo.png'; // Asegúrate de que la ruta sea correcta
import { useNavigate } from 'react-router-dom'; // Importamos useNavigate
import { useAuth } from '../../metodos/AuthContext';
import { useLoading } from '../../utils/LoadingProvider';
import { dufyAdmon , isClientes } from '../../config/constants';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';

const LoginScreen = () => {
  //Declaracion de variables
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  //empresa
  const [empresa, setEmpresa] = useState(dufyAdmon ? 'DUFY ASESORIAS' : '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const {withLoading } = useLoading();

  //cargar config
  const {
    recargarConfiguracion,
  } = useConfiguracion();

  // Hook de navegación
  const { login , guardarEmpresa} = useAuth();
  const navigate = useNavigate();

  //funcion que hace el envio del boton
  const handleSubmit = async (e) => {
    e.preventDefault();
    return withLoading(async () =>{
      // Validación básica
      if (!email.trim()) {
        setError('Por favor, ingresa tu correo electrónico');
        return;
      }
      
      if (!password) {
        setError('Por favor, ingresa tu contraseña');
        return;
      }
      
      try {
        setError('');
        setLoading(true);
        
        //guardar clave
        guardarEmpresa(empresa)

        // Autenticación con Firebase
        await login(email, password);

        //recargar configuracion
        await recargarConfiguracion();
        
        // Redirigir al usuario a la ruta /home
        navigate('/');
        
        //alert('Login exitoso!'); //llamar alertas
        
      } catch (error) {
        setError('Error al iniciar sesión. Verifica tus credenciales.');
        console.error('Error de login:', error);
      } finally {
        setLoading(false);
      }
    });
  };

  //registrar usuario
  const registerUsuario = async (e) => {
    navigate('/registro');
  }

  const registerCliente = async (e) =>{
    navigate('/registroCliente');
  }

  //olvidar contraseña
  const contrasenaOlvidada = async (e) => {
    navigate('/recuperar-contrasena');
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src={logo} alt="Logo de la aplicación" />
        </div>
        
        <h2>Iniciar Sesión</h2>
        
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>

          {!dufyAdmon && (
            <div className="form-group">
              <label htmlFor="empresa">Empresa</label>
              <input
                type="text"
                id="empresa"
                value={empresa}
                onChange={(e) => setEmpresa(e.target.value)}
                placeholder="Nombre de la empresa"
                required={!dufyAdmon}
              />
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Correo electrónico</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ejemplo@correo.com"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
              required
            />
          </div>

          <div className="form-options">
            <div className="remember-me">
              <input type="checkbox" id="remember" />
              <label htmlFor="remember">Recordarme</label>
            </div>
            
            <div className="forgot-container">
            <button 
              onClick={contrasenaOlvidada} 
              className="forgot-link"
              type="button">
              ¿Olvidaste tu contraseña?
            </button> 

            </div>
          </div>
          
          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        {!isClientes && (
          <button 
            onClick={registerUsuario} 
            className="team-link"
            type="button"
          >
            Se parte del equipo
          </button>
        )}
        
        <button 
          onClick={registerCliente} 
          className="team-link"
          type="button"
        >
          Registro de cliente
        </button>
        
        <div className="version-container">
          <span className="version">{process.env.REACT_APP_VERSION}</span>
        </div>



      </div>
    </div>
  );

};

export default LoginScreen;